<template>
    <article id="eventos">
        <Banner/>
        <div class="container">
            <Evento
                v-for="(evento, index) in eventos"
                :key="index"
                :id="index"
                :nome="evento.nome"
                :imagem="evento.imagem.length == 0 ? background : evento.imagem"
                :data="evento.data"
                :descricao="evento.descricao"
                :valor="evento.valor"
                :endereco="evento.endereco"
                :link="evento.link"
            />
        </div>
    </article>
</template>

<script>

import ImgEventoRave from '@/assets/img/eventos/rave-maniaca.jpg'
import ImgEventoMulheres from '@/assets/img/eventos/especial-dia-mulheres.jpg'
import ImgEventoChoco from '@/assets/img/eventos/choco-maniacos.jpg'

import ImgEvento from '@/assets/img/eventos/sm2020.jpg'

import Banner from './components/Banner'
import Evento from './components/Evento'

export default {
    name: 'Eventos',
    components: {
        Banner,
        Evento
    },
    data () {
        return {
            eventos: [],
            background: ImgEvento
        }
    },
    mounted () {
        this.eventos = [
            {
                nome: 'Rave Maníaca',
                imagem: ImgEventoRave,
                data: {
                    dia: '27',
                    mes: '02',
                    hora: '22:00'
                },
                descricao: '09 horas de baile com café da manhã incluso<br><br>Dj Rapha e Dj Hugo dutra<br>Abertura: Dj Vinicius e Dj  Duda Accacio',
                valor: {
                    preco: '25,00',
                    descricao: 'Valor único'
                },
                endereco: 'Cachanga do malandro, R. da lapa 230 - LAPA',
                link: {
                    url: 'https://www.link.com.br/evento',
                    texto: 'Site do evento'
                }
            },
            {
                nome: 'Especial dia das mulheres',
                imagem: ImgEventoMulheres,
                data: {
                    dia: '21',
                    mes: '03',
                    hora: ''
                },
                descricao: '',
                valor: {
                    preco: '',
                    descricao: ''
                },
                endereco: '',
                link: {
                    url: '',
                    texto: ''
                }
            },
            {
                nome: 'Chocomaníacos',
                imagem: ImgEventoChoco,
                data: {
                    dia: '04',
                    mes: '04',
                    hora: ''
                },
                descricao: '',
                valor: {
                    preco: '',
                    descricao: ''
                },
                endereco: '',
                link: {
                    url: '',
                    texto: ''
                }
            },
            {
                nome: 'Baile oficial de lançamento SN 2020',
                imagem: '',
                data: {
                    dia: '02',
                    mes: '05',
                    hora: ''
                },
                descricao: '',
                valor: {
                    preco: '',
                    descricao: ''
                },
                endereco: '',
                link: {
                    url: '',
                    texto: ''
                }
            },
            {
                nome: 'SM do amor',
                imagem: '',
                data: {
                    dia: '13',
                    mes: '06',
                    hora: ''
                },
                descricao: '',
                valor: {
                    preco: '',
                    descricao: ''
                },
                endereco: '',
                link: {
                    url: '',
                    texto: ''
                }
            },
            {
                nome: 'B-day Léo Fortes',
                imagem: '',
                data: {
                    dia: '11',
                    mes: '07',
                    hora: ''
                },
                descricao: '',
                valor: {
                    preco: '',
                    descricao: ''
                },
                endereco: '',
                link: {
                    url: '',
                    texto: ''
                }
            },
            {
                nome: 'SM especial dia dos pais',
                imagem: '',
                data: {
                    dia: '08',
                    mes: '08',
                    hora: ''
                },
                descricao: '',
                valor: {
                    preco: '',
                    descricao: ''
                },
                endereco: '',
                link: {
                    url: '',
                    texto: ''
                }
            },
            {
                nome: 'SM 2020 - Evento oficial',
                imagem: '',
                data: {
                    dia: '24, 25, 26, 27',
                    mes: '09',
                    hora: ''
                },
                descricao: '',
                valor: {
                    preco: '',
                    descricao: ''
                },
                endereco: '',
                link: {
                    url: '',
                    texto: ''
                }
            },
            {
                nome: 'Ressaca maníaca',
                imagem: '',
                data: {
                    dia: '28',
                    mes: '09',
                    hora: ''
                },
                descricao: '',
                valor: {
                    preco: '',
                    descricao: ''
                },
                endereco: '',
                link: {
                    url: '',
                    texto: ''
                }
            }
        ]
    }
}
</script>

<style lang="sass">
    #eventos
        width: 100vw
</style>
